<app-header></app-header>
    <router-outlet></router-outlet>
<app-footer></app-footer>

<div id="ftco-loader" class="fullscreen" [ngClass]="{'show': isloading == true}"><svg class="circular" width="48px" height="48px"><circle class="path-bg" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke="#eeeeee"/><circle class="path" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="#111827"/></svg></div>
